// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../fichesalarie/listerubriques/listerubriquessalarie.ts" />
import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalUpdate extends Vue {
    public rubrique: RubriqueDto = { Id: 0, Modifiable: true, EstArchivee: false, EstVariable: false };
	public parametres: ParametreDto[] = [];
	public currentOrberColumn = "Libelle";

	public filterName = "";
	public currentOrderColumn = "LibelleRubrique";
	public orderingDesc = true;
	public arrondis: ParametreDto[] = ParametresInstance.listeArrondis;
	public isLoading = false;
	public estModifie = false;

	public Init(idRubrique: number): void {
		this.estModifie = false;
		this.isLoading = true;
		ServicesFactoryInstance.ParametresService.getParametresGenerauxAssocies(idRubrique, data => {
			this.arrondis = ParametresInstance.listeArrondis;
			this.parametres = data;
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});

		this.$forceUpdate();
    	this.doOrder();
	}

	public annuler(): void {
    	this.$emit("refresh");
    	$("#modalUpdate").modal("hide");
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrberColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrberColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	if (this.parametres != undefined) {
    		this.parametres.sort(this.sortFunction);
    	}
	}

	public sortFunction(a: any, b: any): number {
    	if (a[this.currentOrberColumn] < b[this.currentOrberColumn]) {
			return (this.orderingDesc ? -1 : 1);
		}
    	if (a[this.currentOrberColumn] > b[this.currentOrberColumn]) {
			return (this.orderingDesc ? 1 : -1);
		}

    	return 0;
	}

	public update(): void {
    	NotificationServiceInstance.SendInformation("Mise à jour des scénarios et des contrats actifs en cours, merci de patienter.");
    	this.isLoading = true;
    	ServicesFactoryInstance.ParametreService.updateParametreRubContrat(this.parametres, () => {
			NotificationServiceInstance.SendSuccess("Les scénarios et les contrats actifs ont bien été mis à jour.");

			// Actualisation des paramètres instanciés succeptibles d'être impactés.
			ParametresInstance.refreshListeQualifications();
			ParametresInstance.refreshListeConventions();
			ParametresInstance.refreshListeRemunerations();

    		this.isLoading = false;
    		this.$emit("refresh");
    		this.annuler();
    	}, () => {
			this.isLoading = false;
		});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrberColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public calculeResultat(parametre: ParametreDto): void {
    	if (parametre == undefined) {
			return;
		}
    	if (parametre.Valeur1 == undefined || parametre.Valeur2 == undefined) {
			return;
		}

    	parametre.Valeur3 = this.fixRounding(parametre.Valeur1 * parametre.Valeur2, 5);

		this.arronditResultat(parametre);

		this.modifier();
	}

	public arronditResultat(parametre: ParametreDto): void {
    	if (parametre == undefined) {
			return;
		}
    	if (parametre.Valeur3 == undefined) {
			return;
		}
    	if (parametre.CodeArrondi3 == undefined) {
			return;
		}

    	const arrondi = this.arrondis.filter(a => a.Code == parametre.CodeArrondi3)[0];
    	if (arrondi == undefined || arrondi.Valeur1 == undefined) {
			return;
		}

    	// On applique la précision à la valeur pour travailler sur l'arrondi d'un nombre entier.
    	let valeurAvecPrecision: number = parametre.Valeur3 / arrondi.Valeur1;
    	const precision = Math.round(Math.log(arrondi.Valeur1) / -Math.LN10);

    	if (arrondi.Valeur2 == 1) {
    		// Arrondi inférieur.
    		valeurAvecPrecision = Math.floor(valeurAvecPrecision);
    	} else if (arrondi.Valeur2 == 2) {
    		// Arrondi supérieur.
    		valeurAvecPrecision = Math.ceil(valeurAvecPrecision);
    	} else {
    		// Arrondi à l'entier le plus proche.
    		valeurAvecPrecision = Math.round(valeurAvecPrecision);
    	}

    	parametre.Valeur3 = this.fixRounding(valeurAvecPrecision * arrondi.Valeur1, precision);
	}

	// En javascript, les opérations, c'est à une vache près, c'est pas une science exacte.
	public fixRounding(value: number, precision: number): number {
    	const power = Math.pow(10, precision || 0);

    	return Math.round(value * power) / power;
	}

	public modifier(): void {
		this.estModifie = true;
	}
}



// WEBPACK FOOTER //
// ./src/components/parametresSpecifiques/modalUpdate/modalUpdate.ts